import React from 'react';
// comps
import Soldier from "./Soldier";

const SoldierList = ({ soldiers }) => {

    return (
        <div>
            {
                soldiers.map((soldierData, index) => {
                    return <Soldier key={soldierData.uid} data={soldierData} openBiog={index === 0}/>
                })
            }

        </div>
    )
};

export default SoldierList;


// WEBPACK FOOTER //
// ./src/app/components/SoldierList.js